module.exports = __webpack_public_path__ + "img/user-menu-female.390ffe7b.png";